export const RECORD_STATE = [
  {
    label: '待确认',
    value: 1,
    color: '#e6ad00',
  },
  {
    label: '待处理',
    value: 3,
    color: '#4b88ff',
  },
  {
    label: '已完成',
    value: 4,
    color: '#56b502',
  },
]

export const Gender = [
  {
    label: '男',
    value: 1,
  },
  {
    label: '女',
    value: 2,
  },
]

export const platform = [
  {
    label: '预付费系统',
    value: 1,
    serviceType: 'prepay',
  },
  {
    label: '综合能源服务平台',
    value: 2,
    serviceType: 'energy',
  },
  {
    label: 'IoT平台',
    value: 3,
    serviceType: 'things',
  },
]

export const APP_STATUS = [
  {
    label: '待上架',
    value: 0,
  },
  {
    label: '可供应用',
    value: 1,
  },
  {
    label: '已下架',
    value: 2,
  },
]

// 运行环境
export const RUNTIME = [
  {
    value: 0,
    label: 'Arm',
  },
  {
    value: 1,
    label: 'Python',
  },
  {
    value: 2,
    label: 'Lua',
  },
  {
    value: 3,
    label: 'Shell',
  },
]

// 设备类型
export const DEVICE_TYPE = [
  {
    value: 0,
    label: '直连设备',
  },
  {
    value: 1,
    label: '网关设备',
  },
  {
    value: 2,
    label: '子设备',
  },
]

// 功能类型
export const FUNCTION_TYPE = [
  {
    // 0: 属性 1：事件 2:服务
    functionType: 0,
    feature: 'properties',
    featureName: '属性',
    disable: false,
  },
  {
    functionType: 1,
    feature: 'events',
    featureName: '事件',
    disable: false,
  },
  {
    functionType: 2,
    feature: 'services',
    featureName: '动作',
    disable: false,
  },
]

// 属性定义数据类型
export const PROPERTY_DATA_FORMAT = [
  {
    label: '整数型（int32）',
    value: 'int',
  },
  {
    label: '单精度浮点型（float）',
    value: 'float',
  },
  {
    label: '双精度浮点型（double）',
    value: 'double',
  },
  {
    label: '时间型（date）',
    value: 'date',
  },
  {
    label: '枚举型（enum）',
    value: 'enum',
  },
  {
    label: '布尔型（bool）',
    value: 'bool',
  },
  {
    label: '字符型（text）',
    value: 'text',
  },
]

// 数据传输类型
export const DATA_TRANS_TYPE = [
  {
    value: 0,
    label: '读写',
  },
  {
    value: 1,
    label: '只读',
  },
]

// 不同类型的边界范围
export const MIN_MAX = {
  int: ['-2147483648', '2147483647'],
  float: [
    '-340282346638528860000000000000000000000',
    '340282346638528860000000000000000000000',
  ],
  double: ['-1.7E-308', '1.7E+308'],
}

// 数据格式
export const DATA_FORMAT = [
  {
    value: 0,
    label: '标准数据格式（Json）',
  },
  {
    value: 1,
    label: '透传/自定义',
  },
]

// 数据校验方式
export const DATA_VERIFY_LEVEL = [
  {
    value: 0,
    label: '弱校验',
  },
  {
    value: 1,
    label: '免校验',
  },
]

// 数据迁移校验-状态
export const DATA_STATUS = [{
  value: 0,
  label: '未同步',
}, {
  value: 1,
  label: '成功',
}, {
  value: 2,
  label: '失败',
}, {
  value: 3,
  label: '同步中',
}]

// 数据迁移校验-拓扑关系一致性
export const TOPOLOY_CONSISTENCY = [{
  value: 0,
  label: '未比较',
}, {
  value: 1,
  label: '一致',
}, {
  value: 2,
  label: '不一致',
}]

// 设备类型-下拉筛选
export const DEVICE_TYPE_DROP = [{
  value: 'all',
  label: '全部',
  columns: '设备类型',
  key: 'deviceType', // 用这个字段区分每个页面不同的表头
}, {
  value: 0,
  label: '直连设备',
  columns: '设备类型',
  key: 'deviceType',
}, {
  value: 1,
  label: '网关设备',
  columns: '设备类型',
  key: 'deviceType',
}, {
  value: 2,
  label: '子设备',
  columns: '设备类型',
  key: 'deviceType',
}]

// 设备管理 - 列表 - 状态 下拉筛选
export const DEVICE_STATUS_DROP = [{
  value: 'all',
  label: '全部',
  columns: '状态',
  key: 'deviceStatus', // 用这个字段区分每个页面不同的表头
}, {
  value: 1,
  label: '未激活',
  columns: '状态',
  key: 'deviceStatus',
}, {
  value: 2,
  label: '离线',
  columns: '状态',
  key: 'deviceStatus',
}, {
  value: 3,
  label: '在线',
  columns: '状态',
  key: 'deviceStatus',
}, {
  value: 0,
  label: '已禁用',
  columns: '状态',
  key: 'deviceStatus',
}]

// 设备状态
export const DEVICE_STATUS = [{
  value: 1,
  label: '未激活',
}, {
  value: 2,
  label: '离线',
  disable: true,
}, {
  value: 3,
  label: '在线',
  disable: true,
}, {
  value: 0,
  label: '已禁用',
  disable: true,
}]

// 问题类型
export const FEEDBACK_TYPE = [{
  value: 0,
  label: '设备问题',
}, {
  value: 1,
  label: '使用建议',
}, {
  value: 2,
  label: '其他问题',
}]

// 问题状态
export const FEEDBACK_STATUS = [{
  value: 0,
  label: '待处理',
}, {
  value: 1,
  label: '已处理',
}]

// 匹配状态
export const MATCH_STATUS = [
  {
    value: '0',
    label: '未匹配',
  },
  {
    value: '1',
    label: '匹配成功',
  },
]
